import "./src/styles/global.css"

// Ensure fonts are loaded before hydration
export const onClientEntry = () => {
  // Force a repaint to ensure fonts are applied
  if (typeof document !== "undefined") {
    document.fonts.ready.then(() => {
      // Trigger a small layout recalculation to ensure fonts are applied
      void document.body.offsetHeight // Force repaint
    })
  }
}
